import Vue from "vue";
import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import ElementUI from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
import "@/styles/theme/index.css";
import "@/styles/index.less"; // global css
import App from "./App";
import store from "./store";
import router from "./router";
import "@/icons"; // icon
import "@/permission"; // permission control
import * as echarts from "echarts";
import Bus from "./utils/bus";
// import ZmTreeOrg from "zm-tree-org";
// import "zm-tree-org/lib/zm-tree-org.css";

// Vue.use(ZmTreeOrg);
// import Vue2OrgTree from "vue2-org-tree";
// Vue.use(Vue2OrgTree);
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 *
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
Vue.prototype.$bus = Bus;
Vue.prototype.$echarts = echarts;
// Vue.prototype.$zoomcharts = window.NetChart;
Vue.prototype.$color = [
  "RGBA(26, 210, 207, 1)",
  "RGBA(198, 6, 223, 1)",
  "RGBA(206, 210, 19, 1)",
  "RGBA(206, 95, 19, 1)",
  "RGBA(14, 182, 223, 1)",
  "RGBA(206, 210, 19, 1)",
  "RGBA(121, 255, 120,1)",
  "RGBA(41, 143,237,1)",
  "RGBA(59, 212, 151,1)",
  "RGBA(62, 248 ,249,1)",
  "RGBA(23, 82, 172,1)",
  "RGBA(255 ,139, 3,1)",
  "RGBA(91 ,125, 215,1)",
  "RGBA(91 ,215 ,181,1)",
  "RGBA(215, 196 ,91,1)",
  "RGBA(91, 215, 93,1)",
  "RGBA(122, 91 ,215,1)",

  //循环
  "RGBA(26, 210, 207, 1)",
  "RGBA(198, 6, 223, 1)",
  "RGBA(206, 210, 19, 1)",
  "RGBA(206, 95, 19, 1)",
  "RGBA(14, 182, 223, 1)",
  "RGBA(206, 210, 19, 1)",
  "RGBA(121, 255, 120,1)",
  "RGBA(41, 143,237,1)",
  "RGBA(59, 212, 151,1)",
  "RGBA(62, 248 ,249,1)",
  "RGBA(23, 82, 172,1)",
  "RGBA(255 ,139, 3,1)",
  "RGBA(91 ,125, 215,1)",
  "RGBA(91 ,215 ,181,1)",
  "RGBA(215, 196 ,91,1)",
  "RGBA(91, 215, 93,1)",
  "RGBA(122, 91 ,215,1)",
  //循环
  "RGBA(26, 210, 207, 1)",
  "RGBA(198, 6, 223, 1)",
  "RGBA(206, 210, 19, 1)",
  "RGBA(206, 95, 19, 1)",
  "RGBA(14, 182, 223, 1)",
  "RGBA(206, 210, 19, 1)",
  "RGBA(121, 255, 120,1)",
  "RGBA(41, 143,237,1)",
  "RGBA(59, 212, 151,1)",
  "RGBA(62, 248 ,249,1)",
  "RGBA(23, 82, 172,1)",
  "RGBA(255 ,139, 3,1)",
  "RGBA(91 ,125, 215,1)",
  "RGBA(91 ,215 ,181,1)",
  "RGBA(215, 196 ,91,1)",
  "RGBA(91, 215, 93,1)",
  "RGBA(122, 91 ,215,1)",
  //循环
  "RGBA(26, 210, 207, 1)",
  "RGBA(198, 6, 223, 1)",
  "RGBA(206, 210, 19, 1)",
  "RGBA(206, 95, 19, 1)",
  "RGBA(14, 182, 223, 1)",
  "RGBA(206, 210, 19, 1)",
  "RGBA(121, 255, 120,1)",
  "RGBA(41, 143,237,1)",
  "RGBA(59, 212, 151,1)",
  "RGBA(62, 248 ,249,1)",
  "RGBA(23, 82, 172,1)",
  "RGBA(255 ,139, 3,1)",
  "RGBA(91 ,125, 215,1)",
  "RGBA(91 ,215 ,181,1)",
  "RGBA(215, 196 ,91,1)",
  "RGBA(91, 215, 93,1)",
  "RGBA(122, 91 ,215,1)"
];
Vue.prototype.$color2 = [
  "RGBA(109, 238, 43, 1)",
  "RGBA(73, 217, 215, 1)",
  "RGBA(237, 197, 67, 1)",
  "RGBA(92, 227, 176, 1)",
  "RGBA(91, 125, 215, 1)",
  "RGBA(236, 220, 137, 1)",
  "RGBA(255, 59, 223, 1)",
  "RGBA(109, 238, 43, 1)",
  "RGBA(73, 217, 215, 1)",
  "RGBA(237, 197, 67, 1)",
  "RGBA(92, 227, 176, 1)",
  "RGBA(91, 125, 215, 1)",
  "RGBA(236, 220, 137, 1)",
  "RGBA(255, 59, 223, 1)",
  "RGBA(109, 238, 43, 1)",
  "RGBA(73, 217, 215, 1)",
  "RGBA(237, 197, 67, 1)",
  "RGBA(92, 227, 176, 1)",
  "RGBA(91, 125, 215, 1)",
  "RGBA(236, 220, 137, 1)",
  "RGBA(255, 59, 223, 1)",
  "RGBA(109, 238, 43, 1)",
  "RGBA(73, 217, 215, 1)",
  "RGBA(237, 197, 67, 1)",
  "RGBA(92, 227, 176, 1)",
  "RGBA(91, 125, 215, 1)",
  "RGBA(236, 220, 137, 1)",
  "RGBA(255, 59, 223, 1)",
  "RGBA(109, 238, 43, 1)",
  "RGBA(73, 217, 215, 1)",
  "RGBA(237, 197, 67, 1)",
  "RGBA(92, 227, 176, 1)",
  "RGBA(91, 125, 215, 1)",
  "RGBA(236, 220, 137, 1)",
  "RGBA(255, 59, 223, 1)",
  "RGBA(109, 238, 43, 1)",
  "RGBA(73, 217, 215, 1)",
  "RGBA(237, 197, 67, 1)",
  "RGBA(92, 227, 176, 1)",
  "RGBA(91, 125, 215, 1)",
  "RGBA(236, 220, 137, 1)",
  "RGBA(255, 59, 223, 1)",
  "RGBA(109, 238, 43, 1)",
  "RGBA(73, 217, 215, 1)",
  "RGBA(237, 197, 67, 1)",
  "RGBA(92, 227, 176, 1)",
  "RGBA(91, 125, 215, 1)",
  "RGBA(236, 220, 137, 1)",
  "RGBA(255, 59, 223, 1)"
];
Vue.prototype.$color3 = [
  "#ff4343",
  "#f69846",
  "#f6d54a",
  "#45dbf7",
  "#44aff0",
  "#ff4343",
  "#f69846",
  "#f6d54a",
  "#45dbf7",
  "#44aff0"
];
Vue.prototype.$color4 = [
  "RGBA(65, 155, 247, 1)",
  "RGBA(126, 205, 230, 1)",
  "RGBA(0, 199, 200, 1)",
  "RGBA(136, 221, 117, 1)",
  "RGBA(253, 212, 99, 1)",
  "RGBA(249, 102, 121, 1)",
  "RGBA(227, 125, 203, 1)",
  "RGBA(158, 87, 219, 1)",
  "RGBA(96, 85, 212, 1)"
];
Vue.prototype.$info = {
  //储备项目
  cbxm: {
    //产业结构
    cyjg: [
      { type: "数字经济", num: "43", total: "221.55" },
      { type: "信息技术应用及装备", num: "31", total: "50.7" },
      { type: "智能制造", num: "71", total: "723" },
      { type: "生命健康", num: "40", total: "124.1" },
      { type: "新材料和氢能", num: "22", total: "318.1" },
      { type: "现代服务业", num: "54", total: "678.55" },
      { type: "总数", num: "261", total: "2116" }
    ],
    //投资结构
    tzjg: [
      { name: "1-10亿", value: 110 },
      { name: "10-20亿", value: 54 },
      { name: "20-50亿", value: 36 },
      { name: "50-100亿", value: 3 },
      { name: "100亿以上", value: 1 }
    ]
  },
  //开工项目
  kgxm: [
    {
      name: "百亿以上",
      value: 7,
      list: [
        { name: "方大生命健康产业小镇", gis: "123.589049,41.8111" },
        { name: "国家蛋白质•沈抚生命科学园", gis: "123.648971,41.808579" },
        { name: "瀚华金融生态小镇", gis: "123.625613,41.818632" },
        { name: "新概念国际教育小镇", gis: "123.676115,41.822537" },
        { name: "圣丰科技小镇", gis: "123.65502,41.825773" },
        { name: "恒大养生谷", gis: "123.703452,41.807167" },
        { name: "沈抚示范区生命健康产业园", gis: "123.615227,41.770146" }
      ]
    },
    {
      name: "50至100亿",
      value: 2,
      list: [
        { name: "汇置尚新城（爱琴海奥莱）", gis: "123.704514,41.819236" },
        { name: "沈抚明珠·浑河城", gis: "123.738175,41.857991" }
      ]
    },
    {
      name: "20至50亿",
      value: 4,
      list: [
        { name: "未来学习城", gis: "123.694809,41.819074" },
        { name: "天年大数据医疗产业园", gis: "123.608404,41.815082" },
        { name: "中金公元启城", gis: "123.6982,41.820658" },
        { name: "七喜精准医疗", gis: "123.614326,41.810492" }
      ]
    },
    {
      name: "1至20亿",
      value: 30,
      list: [
        { name: "中科院金属所沈抚产业基地项目", gis: "123.738562,41.795406" },
        { name: "沈抚供应链基地项目", gis: "123.717582,41.798802" },
        { name: "百利威国际电子商务产业园项目", gis: "123.711295,41.792403" },
        { name: "红塔沈阳烟草产业园项目", gis: "123.637522,41.804199" },
        { name: "海辰5G+工业互联网产业园", gis: "123.697117,41.787547" },
        { name: "中公区域总部一期项目", gis: "123.692792,41.824607" },
        {
          name: "天安智能矿山机械研发生产基地项目",
          gis: "123.719866,41.811303"
        },
        { name: "盛世五寰智能装备基地项目", gis: "123.705088,41.781999" },
        { name: "东北大学工研院项目", gis: "123.734314,41.793711" },
        { name: "丰树国际综合物流产业园项目", gis: "123.632436,41.772291" },
        { name: "广东商会总部项目", gis: "123.645813,41.811408" },
        { name: "山东商会总部项目", gis: "123.654482,41.812335" },
        { name: "辽宁省河北商会总部项目", gis: "123.645427,41.81595" },
        {
          name: "数码雷管模组研发、检测及生产基地项目",
          gis: "123.621751,41.770979"
        },
        { name: "军民融合大厦项目", gis: "123.639077,41.815003" },
        { name: "海创大厦项目", gis: "123.636845,41.818314" },
        { name: "科技创新大厦项目", gis: "123.648958,41.811389" },
        { name: "辽宁省吉林商会总部项目", gis: "123.646935,41.807995" },
        { name: "社会治理管理指挥中心", gis: "123.64559,41.803479" },
        { name: "知识产权保护中心", gis: "123.647456,41.803847" },
        { name: "辽宁省福建商会总部项目", gis: "123.642637,41.81003" },
        { name: "欧柏丽船用直升机平台项目", gis: "123.72153,41.795234" },
        { name: "建龙节能环保研究院总部项目", gis: "123.683608,41.823792" },
        { name: "辽宁省疾病预防控制中心建设项目", gis: "123.643401,41.802839" },
        { name: "IDC机房项目", gis: "123.749055,41.798974" },
        { name: "沈阳百航智能制造研究院项目", gis: "123.691154,41.797487" },
        {
          name: "辽宁晨友新能源汽车电动（热泵）空调系统项目",
          gis: "123.700437,41.790803"
        },
        {
          name: "甲烷氢呼气检测设备生产和检测服务项目",
          gis: "123.652651,41.807807"
        },
        {
          name: "辽宁红银金研殷瓦合金研发生产基地项目",
          gis: "123.726074,41.789679"
        },
        { name: "南京一校南昌中学沈抚校区项目", gis: "123.702598,41.828621" }
      ]
    },
    {
      name: "1亿以下",
      value: 11,
      list: [
        {
          name: "中拓（辽宁）生物科技有限公司工厂建设项目",
          gis: "123.617308,41.790218"
        },
        { name: "恒大盛京世家配建中小学项目", gis: "123.649066,41.833032" },
        {
          name: "工业烟气细颗粒物PM2.5超净排放用超精细滤料生产线项目",
          gis: "123.703543,41.836087"
        },
        { name: "沈抚航飞机器人项目", gis: "123.655424,41.808375" },
        {
          name: "上海眼控科技股份有限公司东北区域公司及人工智能眼控研究院项目",
          gis: "123.654185,41.808311"
        },
        { name: "尚良仲毅沈抚示范区研发基地项目", gis: "123.653418,41.807935" },
        {
          name: "辽宁辽拓大益农机智能制造生产基地项目",
          gis: "123.745901,41.797678"
        },
        { name: "辽宁省职业病防治院建设项目", gis: "123.640163,41.801951" },
        { name: "辽宁沈抚改革创新研究院项目", gis: "123.682997,41.824331" },
        {
          name: "沈阳工业大学国家大学科技园沈抚分园项目",
          gis: "123.684703,41.824831"
        },
        { name: "沈阳理工大学科技园沈抚分园项目", gis: "123.686141,41.825103" }
      ]
    }
  ],
  //签约项目
  qyxm: {
    //产业结构
    cyjg: [
      { name: "数字经济", value: 4, total: 1.7 },
      { name: "信息技术应用及装备", value: 1, total: 45 },
      { name: "智能制造", value: 14, total: 18.1 },
      { name: "生命健康", value: 7, total: 362.6 },
      { name: "新材料和氢能", value: 7, total: 45.1 },
      { name: "现代服务业", value: 55, total: 538.75 }
      // { name: "总数", value: 88, total: 1011.25 }
    ],
    //投资结构
    tzjg: {
      A01: [
        { name: "数字经济", value: 3 },
        { name: "信息技术应用及装备", value: 0 },
        { name: "智能制造", value: 7 },
        { name: "生命健康", value: 3 },
        { name: "新材料和氢能", value: 3 },
        { name: "现代服务业", value: 30 }
      ],
      A02: [
        { name: "数字经济", value: 1 },
        { name: "信息技术应用及装备", value: 0 },
        { name: "智能制造", value: 7 },
        { name: "生命健康", value: 2 },
        { name: "新材料和氢能", value: 2 },
        { name: "现代服务业", value: 18 }
      ],
      A03: [
        { name: "数字经济", value: 0 },
        { name: "信息技术应用及装备", value: 1 },
        { name: "智能制造", value: 0 },
        { name: "生命健康", value: 0 },
        { name: "新材料和氢能", value: 1 },
        { name: "现代服务业", value: 2 }
      ],
      A04: [
        { name: "数字经济", value: 0 },
        { name: "信息技术应用及装备", value: 0 },
        { name: "智能制造", value: 0 },
        { name: "生命健康", value: 0 },
        { name: "新材料和氢能", value: 0 },
        { name: "现代服务业", value: 1 }
      ],
      A05: [
        { name: "数字经济", value: 0 },
        { name: "信息技术应用及装备", value: 0 },
        { name: "智能制造", value: 0 },
        { name: "生命健康", value: 2 },
        { name: "新材料和氢能", value: 0 },
        { name: "现代服务业", value: 3 }
      ]
    }
  }
};
Vue.use(ElementUI, {
  size: "small"
});
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});
